import { cn } from '@/lib/cn';

export function LogoMark({ fill = '#4B0082', glyph = '#FFFFFF', className }: { fill?: string; glyph?: string; className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8 shrink-0', className)} aria-hidden>
      <rect width="32" height="32" rx="8" fill={fill} />
      <path d="M8 23V9h3.2l4.8 7.6L20.8 9H24v14h-3V14.2l-3.9 6.1h-2.2L11 14.2V23H8z" fill={glyph} />
    </svg>
  );
}
